<script>
import Layout from "../../../../router/layouts/print";
import { saletransferService } from "../../../../services/saleservice/saletransfer.service";
import moment from 'moment'
// import { propertyService } from "../../../../services/managements/propertyservice/property.service";
/**
 * Screen component
 */
/* eslint-disable no-console */

export default {
  components: { Layout },
  data() {
    return {
      transferData: {},
      subject: 'ខ្ញុំបាទ',
      partnerName: '',
      partnerNameTo: '',
    };
  },
  mounted() {
        let hasId = 'id' in this.$route.params;
        if(hasId) {
        this.loadingData(this.$route.params.id);     
        } else {
        this.loadingData(0);     
        }
  },

  watch: {
   
  },

  methods: {

    loadingData: function(id) {
      this.fetchingStats = true;
      saletransferService.getDocument(id)
        .then(response => {
          if(id != 0){
              this.transferData = response.data;
              this.subject = 'យើងខ្ញុំ'; //this.transferData.from_sex==2 ? 'នាងខ្ញុំ' : 'ខ្ញុំបាទ';

              // console.log(JSON.stringify(this.transferData));
              this.transferData.from_customer_partners.map((item) => {
                this.partnerName += " / " + item.partner_name;
              });

              this.transferData.to_customer_partners.map((item) => {
                this.partnerNameTo += " / " + item.partner_name;
              });
          }
        });

    },


    formatCurrency(value, sign = '', decimal = '.00') {
      return  sign.length > 1 ? sign + this.$options.filters.numFormat(value, `0,0${decimal}`) : this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);
    },

    dateFormat(date=""){
      var dt = moment(String(date)).format('DD/MM/YYYY');
      var d = dt.split("/");
      return `${d[0]} ខែ${d[1]} ឆ្នាំ${d[2]}`;
    },


    print() {
      window.print();
    },

  },

  props: {
    data: null,
  }

};
</script>
<template>
  <Layout>
        <center >
          <div class="box-a4">
            <div class="col dblack kh font-size: 9pt;">
              <p class="khm sub-title l3" style="margin-top: 0.2cm;">ព្រះរាជាណាចក្រកម្ពុជា</p>
              <p class="khm sub-title l4" style="font-size: 11.5pt;">ជាតិ សាសនា ព្រះមហាក្សត្រ</p>
              <p class="top-0">
                <img src="../../../../assets/images/3symbol-black.svg" style="width: 150px;"/>
              </p>
              <p class="khm sub-title top3">លិខិតស្នើសុំផ្ទេរកិច្ចព្រមព្រៀងលក់-ទិញ លំនៅឋាន</p>
              <p class="khm" style="margin-top: -20px;">~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~</p>

            </div>
            <div class="row" style="width: 100% !important">
              <div class="col-12 dblack kh font-size: 9pt;">

                <table width="100%">
                  <tr>
                    <td width="100px"  style="vertical-align: top;">
                     <p> <span class="khm h5 dblack"><u>យោង</u></span></p>
                    </td>
                    <td width="10px" style="vertical-align: top;">:</td>
                    <td>
                       <p style="text-align: justify; line-height: 1.8em; font-size: 12pt;">
                            កិច្ចព្រមពៀងលក់-ទិញលំនៅឋានលខៈ RHSS-0124 ចុះថ្ងៃទី 06 ខែ ធ្នូ ឆ្នាំ 2021, រវាងក្រុមហ៊ុន <span class="khm h5 dblack">លំនៅឋាន អេចសុី ឯ.ក</span> តំណាងដោយលោក <span class="khm h5 dblack">លឹម ទ្រី</span> (ភាគី “ក”) កាន់អត្តសញ្ញាណប័ណ្ណជាតិខ្មែរលេខ: 011335234 ចុះថ្ងៃទី 24-មករា-2019 ការិយាល័យកណា្ដលដីឡូតិ៍លេខ: 742 ផ្លូវេលខៈ 1952 ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ ។
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td width="100px"  style="vertical-align: top;">
                     <p> <span class="khm h5 dblack"><u>ជាមួយនិង</u></span></p>
                    </td>
                    <td width="10px" style="vertical-align: top;">:</td>
                    <td>
                       <p style="text-align: justify; line-height: 1.8em; font-size: 12pt;">
                            <span>
                                ឈ្មោះ <span class="khm h5 dblack">{{transferData && transferData.from_name}}</span> ភេទៈ {{transferData && transferData.from_sex == 2 ? 'ស្រី' : 'ប្រុស'}} កាន់អត្តសញ្ញាណប័ណ្ណសញ្ជាតិខ្មែរលេខ: {{transferData && transferData.from_id_no}} ចុះថ្ងៃទី {{transferData && transferData.from_id_date_text}} ។
                            </span>
                            <span v-for="(partner, index) in transferData.from_customer_partners" :key="index">
                                <br />
                                ឈ្មោះ <span class="khm h5 dblack">{{partner && partner.partner_name}}</span> ភេទៈ {{partner && partner.sex}} កាន់អត្តសញ្ញាណប័ណ្ណសញ្ជាតិខ្មែរលេខ: {{partner && partner.partner_id_no}} ចុះថ្ងៃទី {{partner && partner.partner_id_date_show}} ។
                            </span>
                            <br/>
                            <span>
                               អាសយដ្ឋានបច្ចុប្បន្ន: {{transferData && transferData.from_address}}។ ទូរស័ព្ទេលខៈ {{transferData && transferData.from_phone_no_1}} (ហៅថាភាគី “ខ”) ។
                            </span>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3" style="vertical-align: top;">
                      <div class="col dblack  kh font-size: 9pt;">
                        <center>
                        <p class="khm sub-title"><u>សូមគោរពជូន</u></p>
                        <p class="khm sub-title" style="font-size: 11.5pt;">លោកនាយកក្រុមហ៊ុនលំនៅឋាន អេចស៊ី ឯ.ក</p>
                        </center>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td width="100px"  style="vertical-align: top;">
                     <p> <span class="khm h5 dblack"><u>កម្មវត្ថុ</u></span></p>
                    </td>
                    <td width="10px" style="vertical-align: top;">:</td>
                    <td>
                       <p style="text-align: justify; line-height: 1.8em; font-size: 12pt;">
                          ស្នើសុំផ្ទេរកិច្ចព្រមព្រៀងលក់-ទិញលំនៅឋានលេខ: {{transferData && transferData.sale}} ចុះថ្ងៃទី: {{dateFormat(transferData.for_date)}} (ដូចមានយោងមកខាងលើ)
                          <span class="khm  h5 dblack top3">ទៅឱ្យឈ្មោះ  {{transferData.to_name}}  </span>
                            ភេទ: {{transferData && (transferData.to_sex==2) ? 'ស្រី' : 'ប្រុស'}}
                            ថ្ងៃខែឆ្នាំកំណើត: {{transferData && transferData.to_dob_text}}
                            កាន់អត្តសញ្ញាណប័ណ្ណលេខ: {{transferData && transferData.to_id_no}} ចុះថ្ងៃទី: {{transferData && transferData.to_id_date_text}}
                            អាសយដ្ឋានបច្ចុប្បន្ន: {{transferData && transferData.to_address}}

                            <c v-for="(partner, index) in transferData.to_customer_partners" :key="index">
                              <span class="khm  h5 dblack top3">និងឈ្មោះ  {{partner && partner.partner_name}}  </span>
                              ភេទ: {{partner && partner.sex}}
                              កាន់អត្តសញ្ញាណប័ណ្ណលេខ: {{partner && partner.partner_id_no}} ចុះថ្ងៃទី: {{partner && partner.partner_id_date_show}}
                              អាសយដ្ឋានបច្ចុប្បន្ន: {{transferData && transferData.to_address}} 
                            </c>

                            លេខទូរស័ព្ទលេខ: {{transferData && transferData.to_phone_no_1}}
                            ។ ចាប់ពីថ្ងៃផ្តិតស្នាមមេដៃ លើលិខិតស្នើសុំផ្ទេរកិច្ចព្រមពៀងលក់-ទិញលំនៅឋាននេះតទៅ ។
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td width="100px"  style="vertical-align: top;">
                     <p> <span class="khm h5 dblack"><u>មូលហេតុ</u></span></p>
                    </td>
                    <td width="10px" style="vertical-align: top;">:</td>
                    <td>
                       <p style="text-align: justify; line-height: 1.8em; font-size: 12pt;">
                          {{transferData.reason}}
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3" style="vertical-align: top;">
                      <div class="col dblack  kh font-size: 9pt;">
                        <p style="text-align: justify; font-size: 12pt;">
                  <span style="margin-left: 110px"></span>អាស្រ័យហេតុនេះ សូមលោកនាយកមេត្តាពិនិត្យ និងសម្រេចតាមការស្នើសុំរបស់{{subject}}ដោយក្ដីអនុគ្រោះ។ ហើយថ្លៃសេវាផ្ទេរកិច្ចព្រមព្រៀងលក់-ទិញលំនៅឋានចំនួន: {{transferData && formatCurrency(transferData.fee, '', '')}} ({{transferData && transferData.fee_text}}) ដុល្លារអាមេរិក ជាបន្ទុករបស់{{subject}}។
                </p>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            
            </div>
            

            <div class="row">
              <div class="col dblack  kh font-size: 9pt;">
                <table width="100%">
                  <tr>
                    <td width="35%">
                        <center>
                          <br><br><br>
                          <span class="khm  h5 dblack top3">អ្នកទទួលបន្តកិច្ចព្រមព្រៀង:</span>
                          <br><br>
                          <span style="font-size: 11pt;">បានឃើញ និងឯកភាពទទួលយក</span>
                          <br><br><br>
                          <p class="khm h5 dblack">
                          {{transferData && transferData.to_name}} {{partnerNameTo}}
                          </p>
                        </center>
                    </td>
                    <td  width="30%">
                      <center>
                        <br>
                        <br><br>
                          <span class="khm h5 dblack top3">សាក្សី:</span>
                          <br><br><br><br><br>
                          ....................................................
                        </center>
                    </td>
                    <td  width="35%">
                      <center>
                          <span style="font-size: 11pt;">រាជធានីភ្នំពេញ, ថ្ងៃទី......... ខែ............ ឆ្នាំ.............</span>
                          <br><br>
                          <span class="khm h5 dblack top3">អ្នកផ្ទេរកិច្ចព្រមព្រៀង:</span>
                        
                          <br><br><br><br><br>
                          <p class="khm h5 dblack">
                          {{transferData && transferData.from_name}} {{partnerName}}
                          </p>
                        </center>
                    </td>
                  </tr>
                  <tr>
                    <td>
                        
                    </td>
                    <td>
                      <center>
                        <br>
                        <br><br>
                          <p style="font-size: 11pt;">ថ្ងៃទី......... ខែ............ ឆ្នាំ.............</p>
                          <p class="khm  h5 dblack">នាយកហិរញ្ញវត្ថុ</p>
                          <p style="font-size: 11pt;">បានឃើញ និងឯកភាពតាមការស្នើសុំ</p>
                          <br><br><br>
                          <p class="khm h5 dblack">លឹម ទ្រី</p>
                        </center>
                    </td>
                    <td>
                      
                    </td>
                  </tr>
                </table>
              </div>
            </div>
           </div>
        </center>
  </Layout>
</template>